const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/mental_health_medic/EmptyRouterView.vue");
const MentalHealthHome = () => /* webpackChunkName: "Home" */ import("./../views/mental_health_medic/Home.vue");
const Atention = () => /* webpackChunkName: "MedicAtentions" */ import("./../views/mental_health_medic/medic_atention/medic_Atentions.vue");
const MentalHealthArchive = () =>
  /* webpackChunkName: "MentalHealthArchive" */ import("./../views/mental_health_medic/mental_health_archive/MentalHealthArchive.vue");
const ProfesionalManteiner = () => /* webpackChunkName: "ProfesionalManteiner" */ import("./../views/mental_health_medic/ProfesionalManteiner.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/mental_health",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "mentalHealthHome",
        component: MentalHealthHome,
      },
      {
        path: "atencionMedica",
        name: "mentalHealthHomeAtention",
        component: Atention,
      },
      {
        path: "cartola-salud-mental",
        name: "archiveMentalHealth",
        component: MentalHealthArchive,
      },
      {
        path: "mantenedor-profesionales",
        name: "profesionalManteinerMentalHealth",
        component: ProfesionalManteiner,
      },
      {
        path: "documentacion",
        name: "mentalHealthDocumentation",
        component: Document,
      },
    ],
  },
];
